const GET_FLEET_ASSET_COMMENTS_SAVE = "GET_FLEET_ASSET_COMMENTS_SAVE"
const SET_FLEET_ASSET_COMMENTS_SAVE = "SET_FLEET_ASSET_COMMENTS_SAVE"

const GET_FLEET_ASSET_COMMENTS_HISTORY = "GET_FLEET_ASSET_COMMENTS_HISTORY"
const SET_FLEET_ASSET_COMMENTS_HISTORY = "SET_FLEET_ASSET_COMMENTS_HISTORY"

export{
    GET_FLEET_ASSET_COMMENTS_SAVE,
    SET_FLEET_ASSET_COMMENTS_SAVE,
    GET_FLEET_ASSET_COMMENTS_HISTORY,
    SET_FLEET_ASSET_COMMENTS_HISTORY
}